import { ActivatedRouteSnapshot } from '@angular/router';

/** La catena delle rotte attive, dalla radice alla più profonda (seguendo l'outlet primario). */
export function routeChain(root: ActivatedRouteSnapshot): ActivatedRouteSnapshot[] {
  const chain: ActivatedRouteSnapshot[] = [];
  let current: ActivatedRouteSnapshot | null = root;
  while (current) {
    chain.push(current);
    current = current.firstChild;
  }
  return chain;
}

/** I parametri di tutte le rotte attive, uniti: quelli più profondi prevalgono. */
export function mergedParams(chain: readonly ActivatedRouteSnapshot[]): Record<string, string> {
  const params: Record<string, string> = {};
  for (const route of chain) {
    for (const key of route.paramMap.keys) {
      const value = route.paramMap.get(key);
      if (value !== null) {
        params[key] = value;
      }
    }
  }
  return params;
}

/** Il segmento di indirizzo fino a questa rotta compresa. */
export function urlOf(route: ActivatedRouteSnapshot): string {
  const segments = route.pathFromRoot.flatMap((item) => item.url.map((segment) => segment.path));
  return '/' + segments.join('/');
}

/** Sostituisce i segnaposto `:nome` con i parametri; `null` se ne manca uno. */
export function resolveRoute(
  route: string,
  params: Readonly<Record<string, string>>,
): string | null {
  let missing = false;
  const resolved = route.replace(/:([A-Za-z0-9_]+)/g, (_match, name: string) => {
    const value = params[name];
    if (value === undefined) {
      missing = true;
      return '';
    }
    return encodeURIComponent(value);
  });
  return missing ? null : resolved;
}
